import { Component, OnInit, OnDestroy, HostBinding, AfterViewInit , SimpleChanges, SimpleChange, Input } from '@angular/core';
import { LatestPaymentModel } from '../../../models/consumer/latest-payment.model';
import { HistoryPayments } from '../../../models/consumer/history-payments.model';
import { Router, ActivatedRoute } from '@angular/router';
import { ConsumerService } from '../../../services/consumer.service';
import swal from 'sweetalert2';
import { DataService } from '../../../services/data.service';
import { ConsumerDetailInjector } from '../consumer-detail-injector';

@Component({
    selector: 'payment-item',
    templateUrl: './payment-item.component.html',
})
export class PaymentItemComponent implements AfterViewInit, OnDestroy {

    @Input('issues') issues: any[] = [];

    historyPaymentsPageSize: number = 5;
    historyPaymentsTotalPages: number = 1;
    page: number = 1;
    timePeriod: number = 1;
    consumerId: string;
    subscriptions: any[] = [];
    latestPayment: LatestPaymentModel;
    historyPayments: HistoryPayments[] = [];
    clientId: number;

    constructor(private consumerService: ConsumerService,
        private route: ActivatedRoute,
        private dataService: DataService,
        private router: Router,
        consumerDetailInjector: ConsumerDetailInjector
    ) {
        this.issues = consumerDetailInjector.issues;
    }

    ngAfterViewInit(): void {
        this.subscriptions.push(this.route.queryParams.subscribe(queryParams => {
            this.onInit();
        }));
    }

    onInfoClick() {
        swal({
            title: 'Recent payments',
            html: '<p style="text-align: left;">This widget shows the latest payment made by the consumer.</p>\
             <p style="text-align: left;">You can expand this widget to see the history of payments within the selected date range.</p>',
            confirmButtonText: 'Close',
            confirmButtonColor: '#00539f'
        });
    }

    onInit() {
        this.clientId = this.route.parent.snapshot.params['clientId'];
        this.subscriptions.push(this.route
            .params
            .subscribe(params => {
                this.consumerId = params['consumerId'];
            }));

        this.subscriptions.push(this.route
            .queryParams
            .subscribe(queryParams => {
                if (+queryParams['timePeriod']) {
                    this.timePeriod = +queryParams['timePeriod'];
                }

                if (+queryParams['paymentPage']) {
                    this.page = +queryParams['paymentPage'];
                }
            }));

        this.consumerService.getLatestPayment(this.clientId, this.consumerId).then((paymentsRes) => {
            if (paymentsRes) {
                this.latestPayment = paymentsRes;
            }
        });

        this.consumerService.gethistoryPaymentsPaged(this.clientId, this.page, this.consumerId, this.timePeriod).then((historyPaymentsRes) => {

            var historyResults = (historyPaymentsRes as any);
            if (historyResults && historyResults.items.length > 0) {
                this.dataService.paymentItemComponentResolved.next(true);
                this.historyPayments = historyResults.items;
                this.historyPaymentsPageSize = historyResults.pageSize;
                this.historyPaymentsTotalPages = historyResults.totalPages;
            } else { this.dataService.paymentItemComponentResolved.next(false); }

        }).catch((reson) => {
            this.dataService.paymentItemComponentResolved.next(false);
        });
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    pageSelected(page: number) {
        this.page = page;
        this.getPagedPaymentHistory(page);
    }


    getPagedPaymentHistory(page: number) {

        let queryParams: any = JSON.parse(JSON.stringify(this.route.snapshot.queryParams)) as any;
        queryParams.paymentPage = page;

        this.consumerService.gethistoryPaymentsPaged(this.clientId, page, this.consumerId, this.timePeriod).then((accountRes) => {
            var historyPaymentResults = (accountRes as any);
            if (historyPaymentResults && historyPaymentResults.items.length > 0) {
                this.dataService.paymentItemComponentResolved.next(true);
                this.historyPayments = historyPaymentResults.items;
                this.page = historyPaymentResults.currentPage;
                this.historyPaymentsPageSize = historyPaymentResults.pageSize;
                this.historyPaymentsTotalPages = historyPaymentResults.totalPages;
            } else { this.dataService.paymentItemComponentResolved.next(false); }

        }).catch((reson) => {
            this.dataService.paymentItemComponentResolved.next(false);
        });
    }
}
